import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFooter } from "./footer.service";
import { FooterResponse } from "./footer.types";
import { handleApiError } from "@/app/utils/handleApiError";
import { RootState } from "../../store";
import { RejectValueType } from "../redux/redux.types";

export const getFooter = createAsyncThunk<
  FooterResponse,
  void,
  RejectValueType & { state: RootState }
>(
  "footer/getFooter",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchFooter();
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { footer } = getState();
      if (footer.data) return false;
      if (footer.status === "loading") return false;
      return true;
    },
  },
);